module.exports = __webpack_public_path__ + "img/google-play.525c6c55.svg";